import { AxiosError, AxiosRequestConfig } from 'axios'
import Cookies from 'universal-cookie'
import { COOKIE_LIST } from '../vars'

export const createAxiosTokenConfig = (token: string, data?: any): AxiosRequestConfig => {
  const config: AxiosRequestConfig = {}
  const authToken = token || new Cookies().get(COOKIE_LIST.CAF_TOKEN)
  if (authToken) {
    config.headers = { Authorization: `Bearer ${authToken}` }
  }
  if (data) {
    config.data = data
  }
  return config
}

export const handleAxiosError = (e: AxiosError<any>, customErrMsg = '') => {
  console.error(e)
  return
}
